import { IEditLeadPayload, ILeadCreate, ILeadListSearch } from "../../../../types/sales/leadInterface";
import { IMyLeadListSearch } from "../../../../types/sales/myLeadInterface";
import api from "../../../../lib/api";

export const createLeadApi = async (data: ILeadCreate) => {
  return await api.post(`/sales/lead`, data);
};

export const getLeadListApi = async (data: ILeadListSearch) => {
  return await api.get(`/sales/lead/${data.page}/${data?.pageLimit}?search=${data?.search??""}`)
}

export const getMyLeadListApi = async (data: IMyLeadListSearch) => {
  return await api.get(`/sales/my-lead/${data.page}/${data?.pageLimit}?search=${data?.search??""}`)
}

export const getLeadDataByIdApi = async (id: number) => {
  return await api.get(`/sales/lead/${id}`)
}

export const getMyLeadDataByIdApi = async (id: number) => {
  return await api.get(`/sales/my-lead/${id}`)
}

export const editLeadDataByIdApi = async (payload: IEditLeadPayload) => {
  return await api.put(`/sales/lead/${payload.id}`, payload.data);
};

export const deleteSalesLeadApi = async (id: number) => {
  return await api.delete(`/sales/lead/${id}`);
};